<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <router-link to="detail" class="nav-link">
          <i class="fa fa-vcard-o fa-lg"></i>
          Detail
        </router-link>
      </li>
      <li class="nav-item">
        <router-link to="cards" class="nav-link">
          <i class="fa fa-credit-card fa-lg"></i>
          Credit Cards
        </router-link>
      </li>
      <li class="nav-item">
        <router-link to="references" class="nav-link">
          <i class="fa fa-briefcase fa-lg"></i>
          Trade References
        </router-link>
      </li>
    </ul>

    <div class="tab-content">
      <div class="tab-pane active">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FinancialTab',
  computed: {
    companyId() {
      return this.$route.params.id;
    },
  },
};
</script>
